
<template>
  <div
    v-if="tabDatas"
    class="tabs"
  >
    <!-- tab 切换 -->
    <!-- <tab-nav
      ref="tabNavParent"
      :data="tabDatas"
      :selected="selected"
      :is-anchor="false"
      :fixed="false"
      @change="tabNavChange"
    >
      <a-button
        v-if="showAddBtn"
        class="add-btn"
        :type="addReturnType === 'add' ? 'default' : 'primary'"
        @click="handleAdd"
      >
        {{ addBtnText }}
      </a-button>
    </tab-nav> -->
    <div
      ref="tabNavParent"
      class="tab-nav"
    >
      <ul
        class="nav-bar clearfix"
      >
        <template v-for="(item) in tabDatas">
          <li
            v-show="item.show"
            :key="item.fieldkey"
            :class="{'active': item.fieldkey === selected}"
            @click="tabNavChange(item.fieldkey, $event)"
          >
            {{ item.fieldname }}
          </li>
        </template>
      </ul>
      <a-button
        v-if="showAddBtn"
        class="add-btn"
        :type="addReturnType === 'add' ? 'default' : 'primary'"
        @click="handleAdd"
      >
        {{ addBtnText }}
      </a-button>
    </div>

    <!-- 评论，回访-->
    <div class="containerScroll">
      <keep-alive>
        <component
          :is="tabDatas[selected].component"
          v-if="!loading && tabDatas[selected]"
          ref="content"
          :data="tabDatas[selected].data"
          class="module"
        />
      </keep-alive>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import TabNav from '@/components/pc/TabNav'
import MyForm from './Form'
import ReturnVisite from './ReturnVisite'
import CommentContent from './CommentContent'
import ChangeHistory from './ChangHistory/List'

export default {
  components: {
    TabNav,
    MyForm,
    ReturnVisite,
    CommentContent,
    ChangeHistory
  },
  /* props: {
    detailData: {
      type: Object,
      default: () => { }
    }
  }, */
  data () {
    return {
      selected: '',
      loading: false,
      addReturnType: 'add'
    }
  },
  computed: {
    ...mapGetters('inquery/detailData', ['permissionInfo']),
    from () { // all, my, audit, checkrepeat
      if (this.$route.name === 'InqueryCreate') { // 录入信息
        return 'input'
      } else { // 信息详情
        return this.$route.query.from
      }
    },
    /* tab2 () {
      return this.$route.query.tab2 || 'returnVisite'
    }, */
    tabDatas () {
      if (!this.permissionInfo) return

      let data = {
        returnVisite: {
          fieldkey: 'returnVisite',
          fieldname: this.$t('message["441"]'),
          component: ReturnVisite,
          show: this.permissionInfo.is_show_followups === 1
        },
        commentContent: {
          fieldkey: 'commentContent',
          fieldname: this.$t('message["716"]'),
          component: CommentContent,
          show: this.permissionInfo.is_show_comments === 1
        }
      }
      return data
    },
    showAddBtn () {
      if (this.selected === 'returnVisite') {
        return this.permissionInfo.is_add_followups
      } else if (this.selected === 'commentContent') {
        return this.permissionInfo.is_add_comments
      }
      return false
    },
    addBtnText () {
      let text = ''
      if (this.selected === 'returnVisite') {
        if (this.addReturnType === 'add') {
          text = this.$t('message["1692"]')
        } else if (this.addReturnType === 'edit') {
          text = this.$t('message["40"]')
        }
      } else {
        text = this.$t('message["1351"]')
      }
      return text
    }
  },
  watch: {
    tabDatas: {
      handler (val) {
        if (!this.selected) {
          let arr = Object.values(val)
          this.selected = arr.find(item => item.show).fieldkey
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.setNavStyle()
    })
    this.$bus.$on('changeAddReturnType', this.changeAddReturnType)
  },
  beforeDestroy () {
    this.$bus.$off('changeAddReturnType')
  },
  methods: {
    tabNavChange (k, ev) {
      this.selected = k
      /* this.$router.push({
        query: {
          ...this.$route.query,
          tab2: k
        }
      }) */
    },
    handleAdd () {
      if (this.selected === 'returnVisite') {
        this.$refs.content && this.$refs.content.addVisite()
        this.addReturnType = 'edit'
      } else if (this.selected === 'commentContent') {
        this.$refs.content && this.$refs.content.addComment()
      }
    },
    changeAddReturnType (type) {
      this.addReturnType = type
    },
    setNavStyle () {
      let $containerScroll = document.querySelector('.container-right .containerScroll')
      let $navBar = document.querySelector('.container-right .nav-bar')

      $containerScroll && $containerScroll.addEventListener('scroll', () => {
        const scrollTop = $containerScroll.scrollTop
        if ($navBar && $containerScroll && scrollTop > 0) {
          $navBar.style.borderBottom = 'solid 1px #ebebeb'
        } else {
          $navBar.style.borderBottom = 'none'
        }
      }, false)
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  position: relative;
  height: 100%;
  padding-top: 48px;
  .tab-nav {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 48px;
    background-color: #fff;
    li {
      position: relative;
      float: left;
      margin-right: 24px;
      height: 47px;
      line-height: 47px;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
      &.active {
        color: $primary-color;
        border-bottom: solid 2px $primary-color;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  ::v-deep .nav-wrap {
    overflow: initial;
  }
  ::v-deep .nav-bar {
    margin-right: -40px;
    // border-bottom: solid 1px #ebebeb;
    li {
      position: relative;
      top: 1px;
    }
  }
  .containerScroll {
    height: 100%;
    overflow-y: scroll;
    margin-right: -40px;
    padding-right: 40px;
  }
}
.add-btn {
  position: absolute;
  right: 10px;
  top: 8px;
  z-index: 3;
  margin-right: 0;
  cursor: pointer;
}
</style>
